import Vue from 'vue'
import Datetime from 'vue-datetime'

import { Settings } from 'luxon'

Settings.defaultLocale = 'de'

Vue.use(Datetime)
